import BaseInteriorScene from "../BaseInteriorScene";
import shopSource from "./voidShop-source.json";
import { getVoidCityNpcDialogue } from "../../../@shared/utils/npcDialogs";
import voidShopBg from "../GameMap/InfiNFT Maps/voidShop.png";
import merchantNpcPng from "../../../@shared/assets/GameMaps/tilesets/interior/merchant.png";

const MERCHANT_NPC_KEY = "merchantNpcPortrait";
const MERCHANT_NPC_SCALE = 0.05;
const MERCHANT_FEET_OFFSET_Y = 38;
const MERCHANT_FOREGROUND_DEPTH = 80;
const MERCHANT_FOREGROUND_BLEED_X = 0;
const MERCHANT_FOREGROUND_BLEED_TOP = 0;
const MERCHANT_FOREGROUND_HEIGHT = 40;

export default class VoidCityMerchant extends BaseInteriorScene {
  constructor() {
    super(
      "MerchantScene",
      BaseInteriorScene.extractCollisionDataFromMapSource(
        shopSource,
        "TestCollisions",
      ),
      voidShopBg,
      {
        exit: { to: "VoidCity2Scene", spawnAt: { x: 403, y: 190 } },
      },
      getVoidCityNpcDialogue,
    );
  }

  preload() {
    super.preload();
    this.load.image(MERCHANT_NPC_KEY, merchantNpcPng);
  }

  create(data) {
    super.create(data);

    this.createAmbientInteriorNpc({
      textureKey: "interiorAmbientNpcD",
      x: 236,
      y: 392,
      facing: "left",
    });

    const collisionLayer = shopSource.layers.find(
      (layer) => layer.type === "objectgroup" && layer.name === "TestCollisions",
    );
    const merchantAnchor = collisionLayer?.objects?.find(
      (object) => object.name === "merchant",
    );
    const deskAnchor = collisionLayer?.objects?.find(
      (object) => object.name === "desk",
    );

    if (!merchantAnchor) return;

    const anchorX = merchantAnchor.x + merchantAnchor.width / 2;
    const npcY =
      merchantAnchor.y + merchantAnchor.height + MERCHANT_FEET_OFFSET_Y;

    this.add
      .image(anchorX, npcY, MERCHANT_NPC_KEY)
      .setOrigin(0.5, 1)
      .setScale(MERCHANT_NPC_SCALE)
      .setDepth(70);

    if (deskAnchor) {
      this.add
        .image(0, 0, `${this.scene.key}_bg`)
        .setOrigin(0)
        .setDepth(MERCHANT_FOREGROUND_DEPTH)
        .setCrop(
          deskAnchor.x - MERCHANT_FOREGROUND_BLEED_X,
          deskAnchor.y - MERCHANT_FOREGROUND_BLEED_TOP,
          deskAnchor.width + MERCHANT_FOREGROUND_BLEED_X * 2,
          MERCHANT_FOREGROUND_HEIGHT,
        );
    }
  }
}
